// extracted by mini-css-extract-plugin
module.exports = {"languageName":"Language_languageName__rQO_5","selectData":"Language_selectData__BfQ3q","btnText":"Language_btnText__NeQYr"};